import HttpError from './HttpError';

export default class InvalidDomainError extends HttpError {}
